// Given a zoom level, expand the types that should be included in the geocode
// query param.
const getTypes = zoom => {
  const z = Math.floor(zoom);
  const types = ['country'];

  if (z > 2) {
    types.push('region');
    types.push('district');
  }

  if (z > 5) {
    types.push('place');
    types.push('locality');
  }

  if (z > 10) {
    types.push('neighborhood');
  }

  if (z > 11) {
    types.push('address');
    types.push('poi');
  }

  return types.join(',');
};

export { getTypes };
